import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';
import { AcessoNegadoService } from '../../../refact/shared/services/acesso-negado/acesso-negado.service';

export const PermissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  const authService = inject(AuthService);

  const acessoNegadoService = inject(AcessoNegadoService);

  const requiredPermission = route.data['permissionIntero'] as number;

  if (requiredPermission === undefined || requiredPermission === null) {
    return true;
  }

  if (requiredPermission === 0) {
    return true;
  }

  const hasPermission = authService.getAcess(requiredPermission);

  if (!hasPermission) {
    acessoNegadoService.exibir();
    return false;
  }

  return true;
};
